import React from 'react';
import ExperiencePage from '../components/ExperiencePage';

const AmazonRobotics = () => {
  return (
    <ExperiencePage
      company="Amazon Robotics"
      role="Software Engineer"
      period="January 2013 - September 2013"
      description={[
        "Developed an automated test framework in Java for user authentication and account management",
        "Built a web application to upload and track test results and surface focus areas for future testing"
      ]}
    />
  );
};

export default AmazonRobotics;
